module.exports = __webpack_public_path__ + "static/thelma-7a5457a87eff2de6320232e9c0158d34.jpg";